import { render, staticRenderFns } from "./dosage-form.vue?vue&type=template&id=259ee09c"
import script from "./dosage-form.vue?vue&type=script&lang=js"
export * from "./dosage-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports